export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diffMs = Date.now() - then;
  const sec = Math.round(diffMs / 1000);
  if (sec < 5) return "just now";
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 7) return `${day}d ago`;
  return new Date(iso).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}

/**
 * A series book's volume label — e.g. "Volume 2: STILL", "Volume 2", or "STILL".
 * Null when the book isn't part of a series. Use it wherever a series book's
 * title is shown so the volume travels with it.
 */
export function volumeLabel(p: { seriesName: string | null; seriesNumber: number | null; volumeTitle: string | null }): string | null {
  if (!p.seriesName) return null;
  const num = p.seriesNumber != null ? `Volume ${p.seriesNumber}` : "";
  const name = p.volumeTitle?.trim() ? (num ? `: ${p.volumeTitle.trim()}` : p.volumeTitle.trim()) : "";
  const label = `${num}${name}`.trim();
  return label || null;
}

export function formatNumber(n: number): string {
  return n.toLocaleString();
}

const REASON_LABELS: Record<string, string> = {
  autosave: "Autosaved",
  manual: "Saved",
  restore: "Restored",
  "pre-restore": "Snapshot before restore"
};

export function revisionReasonLabel(reason: string): string {
  return REASON_LABELS[reason] ?? reason;
}

const STATUS_LABELS: Record<string, string> = {
  planning: "Planning",
  drafting: "Drafting",
  revising: "Revising",
  editing: "Editing",
  complete: "Complete"
};

export function statusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status;
}
